/** Mirrors backend/src/categories.js — used if API omits imageCategories/videoCategories. */
export const IMAGE_CATEGORIES = [
  "Meditation",
  "Brain Gym Exercise",
  "BlindFold",
  "Rewards",
  "News & Interview",
  "Events & Workshop",
];

export const VIDEO_CATEGORIES = [
  "Live Sessions",
  "Blind Fold",
  "Parents Review",
  "Kid Reviews",
  "News & Interview",
  "Events & Workshop",
];

export const ALL_CATEGORIES = Array.from(
  new Set([...IMAGE_CATEGORIES, ...VIDEO_CATEGORIES])
);
